import React from 'react';
import { RefreshCw, CloudOff, AlertCircle } from 'lucide-react';

interface SyncStatusProps {
    pendingCount: number;
    isSyncing: boolean;
    lastError: string | null;
    onSync: () => void;
}

const SyncStatus: React.FC<SyncStatusProps> = ({ pendingCount, isSyncing, lastError, onSync }) => {
    if (pendingCount === 0 && !lastError) return null;

    return (
        <div className={`
            flex items-center gap-3 px-4 py-2 rounded-lg text-sm border shadow-sm transition-all
            ${lastError ? 'bg-red-50 border-red-200 text-red-700' : 'bg-orange-50 border-orange-200 text-orange-800'}
        `}>
            {lastError ? (
                <AlertCircle size={16} />
            ) : (
                isSyncing ? <RefreshCw size={16} className="animate-spin" /> : <CloudOff size={16} />
            )}

            <div className="flex-1">
                {lastError ? (
                    <span className="font-bold">Erro no envio</span>
                ) : (
                    <span className="font-bold">{pendingCount} itens pendentes</span>
                )}
            </div>

            <button
                onClick={onSync}
                disabled={isSyncing}
                className="text-xs font-bold underline hover:no-underline disabled:opacity-50"
            >
                {isSyncing ? 'Enviando...' : 'Tentar Agora'}
            </button>
        </div>
    );
};

export default SyncStatus;
